import React from 'react'

import { useAuth } from 'src/modules/auth'
import { Header, useIsMobile } from 'src/modules/ui'

import { useApp } from '../hooks'
import HubspotModal from './HubspotModal'
import Notifications from './Notifications'

const AppHeader = () => {
  const {
    hasEnvironments,
    hasPermission,
    loggedIn,
    signOut,
    user,
    userType,
    featureSwitches,
  } = useAuth()
  const { unreadConversations, unreadNotifications } = useApp()
  const isMobile = useIsMobile()

  const allowedByFeatureSwitch = featureSwitch => {
    return (
      featureSwitches &&
      featureSwitches.hasOwnProperty(featureSwitch) &&
      featureSwitches[featureSwitch] === true
    )
  }

  const wwwRoot = 'https://triedandsupplied.com'
  const loggedOutLinks = [
    {
      exact: true,
      text: 'Login',
      to: '/',
    },
  ]

  const buyerLinks = []
  if (hasPermission('view_approved_suppliers')) {
    buyerLinks.push({
      text: 'Suppliers',
      to: '/suppliers',
    })
  }
  if (hasEnvironments) {
    buyerLinks.push({
      text: 'Purchasing',
      to: '/purchasing',
    })
  }
  if (!isMobile) {
    if (allowedByFeatureSwitch('showRecipes') && hasEnvironments) {
      buyerLinks.push({
        text: 'Recipes',
        to: '/recipes',
      })
    }
  }
  if (allowedByFeatureSwitch('showInvoices') && !isMobile) {
    buyerLinks.push({
      text: 'Invoices',
      to: '/invoices',
    })
  }
  // if (hasEnvironments) {
  //   buyerLinks.push({
  //     text: 'Inventory',
  //     to: '/inventory',
  //   })
  // }

  const supplierLinks = [
    {
      text: 'Orders',
      to: '/orders',
    },
  ]
  if (allowedByFeatureSwitch('showInvoices') && !isMobile) {
    supplierLinks.push({
      text: 'Invoices',
      to: '/invoices',
    })
  }
  supplierLinks.push({
    text: 'Customers',
    to: '/customers',
  })
  if (!isMobile) {
    supplierLinks.push({
      text: 'Products',
      to: '/products',
    })
  }

  const navLinksByUserType = {
    buyer: buyerLinks,
    supplier: supplierLinks,
  }
  const navLinks = user && navLinksByUserType[userType]

  const makeMoreLinks = hubspotTrigger => {
    const moreLinks = []

    if (userType === 'supplier' && isMobile) {
      moreLinks.push({
        text: 'Products',
        to: '/products',
      })
      if (allowedByFeatureSwitch('showInvoices')) {
        moreLinks.push({
          text: 'Invoices',
          to: '/invoices',
        })
      }
    }

    if (userType === 'buyer' && isMobile) {
      if (allowedByFeatureSwitch('showRecipes')) {
        moreLinks.push({
          text: 'Recipes',
          to: '/recipes',
        })
      }
      if (allowedByFeatureSwitch('showInvoices')) {
        moreLinks.push({
          text: 'Invoices',
          to: '/invoices',
        })
      }
    }

    if (hasPermission('admin') || userType === 'supplier') {
      moreLinks.push({
        text: 'Organisational Admin',
        to: '/admin',
      })
    }

    moreLinks.push(
      ...[
        {
          text: 'User Profile',
          to: '/profile',
        },
        {
          text: 'Contact Support',
          onClick: hubspotTrigger.onClick,
        },
        {
          text: 'Log Out',
          onClick: signOut,
        },
      ]
    )
    return moreLinks
  }

  return (
    <HubspotModal
      trigger={hubspotTrigger => (
        <Notifications
          trigger={notificationsTrigger => (
            <Header
              homeLoggedOut={wwwRoot}
              loggedIn={loggedIn}
              loggedOutLinks={loggedOutLinks}
              moreLinks={makeMoreLinks(hubspotTrigger)}
              navLinks={navLinks}
              onClickNotifications={notificationsTrigger.onClick}
              unreadConversations={unreadConversations}
              unreadNotifications={unreadNotifications}
            />
          )}
        />
      )}
    />
  )
}

export default AppHeader
